import React from 'react'
import * as R from 'ramda'
import {
  Select,
  MenuItem,
  Typography,
  CircularProgress,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { FormattedMessage, useIntl } from 'react-intl'
import { useTranslationLanguageNotification } from 'app/components/notificationCard/useTranslationLanguageNotification'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { FuseAnimateGroup } from '@fuse'
import Loader from 'app/components/Loader'

const useStyles = makeStyles((theme) => ({
  darkGreyText: {
    color: theme.palette.darkGrey.main,
  },
  selectIcon: {
    display: 'none',
  },
  languageSelect: {
    '& .MuiInputBase-inputSelect': {
      paddingRight: '0px',
      paddingLeft: '4px',
    },
    '& .MuiTypography-root': {
      marginBottom: '.1rem',
    },
  },
  keyIconStyle: {
    color: theme.palette.darkGrey.main,
    fontSize: '1.6rem',
    marginBottom: '0.2rem',
  },
}))

const ViewInButton = ({
  notificationId,
  languageId,
  defaultLanguage,
  Language,
}) => {
  const { formatMessage } = useIntl()
  const classes = useStyles()
  const { languages, languagesOptions, isLoading, fetchTranslationLanguage } =
    useTranslationLanguageNotification(notificationId)
  const translationFailed = formatMessage({
    id: 'notificationTimeline.card.translation.selector.failed',
  })

  return (
    <Select
      disableUnderline={true}
      defaultValue={defaultLanguage.language.name}
      className={clsx(classes.languageSelect, 'pt-4 mb-8')}
      value={R.prop('id', languages)}
      onOpen={fetchTranslationLanguage}
      onChange={(event) => {
        languageId(event.target.value)
        Language(languages[event.target.value])
      }}
      renderValue={() => (
        <div className="flex items-end">
          <Typography
            className={clsx(
              classes.darkGreyText,
              'text-xs text-end pt-2',
              'font-bold',
            )}
          >
            {defaultLanguage.language.name || (
              <FormattedMessage id="notificationTimeline.card.cannotGetLanguageName" />
            )}
          </Typography>
          <KeyboardArrowDownIcon className={clsx(classes.keyIconStyle)} />
        </div>
      )}
      inputProps={{
        classes: {
          icon: classes.selectIcon,
        },
      }}
    >
      {isLoading ? (
        <Loader
          timeout={0}
          isLoading={isLoading}
          placeholder={
            <FuseAnimateGroup
              enter={{ animation: 'fadeIn' }}
              leave={{ animation: 'fadeOut' }}
            >
              <div className="w-full h-full flex m-auto justify-center">
                <CircularProgress color="secondary" size={12} />
              </div>
            </FuseAnimateGroup>
          }
        />
      ) : (
        languagesOptions.map((item) => {
          const { language } = item
          const { id, nativeName, name, isTranslated, subscriberCount } =
            language

          const counting = isTranslated ? '-' : translationFailed

          return (
            <MenuItem key={id} value={id} disabled={!isTranslated}>
              <div className="flex flex-grow">
                <div>
                  <div className="text-14">{nativeName}</div>
                  {name !== 'English' && (
                    <div className="text-12 font-semibold">{name}</div>
                  )}
                </div>
              </div>
              <div className="flex ltr:pl-16 rtl:pr-16">
                <Typography
                  className={clsx(
                    classes.darkGreyText,
                    'text-xs text-end flex content-center',
                  )}
                >
                  {R.isNil(subscriberCount) ? counting : subscriberCount}
                </Typography>
              </div>
            </MenuItem>
          )
        })
      )}
    </Select>
  )
}
export default ViewInButton
